import { IncidentModel } from './incident.model';
import { MissingRequirementsDocumentModel } from './missing-requirements-document.model';

export class MissingRequirementsModel extends IncidentModel {
    public missingDocuments: MissingRequirementsDocumentModel[] = [];
}
